import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '../../configurations/api';
import { adopterUrl, recommendationUrl } from '../../configurations/api/url';
import { saveEmailSuccess, saveEmailFail, recommendSuccess, recommendFail } from './actions';
import { IRecommend, types } from './types';
import { globalErrorHandler } from '../error/saga';
import { SentryCapture } from '../../analytics/Sentry';
import { showToastMessage } from '../../utils/AppUtils';
import { httpRequest } from '../types';

function* saveAdopter({ payload, resolve, reject }: any): any {
    try {
        const response = yield call(api, adopterUrl, 'POST', payload);
        const { data } = response;
        yield put(saveEmailSuccess(data.data));
        yield call(showToastMessage, 'Email saved successfully', 'success');
        if (resolve) {
            resolve(response);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(saveEmailFail(error));
        yield call(globalErrorHandler, error);
        if (reject) {
            reject(error);
        }
    }
}

function* recommend({ payload }: { payload: IRecommend }): Generator<any, any, any> {
    try {
        yield call(api, recommendationUrl, httpRequest.POST, payload);
        yield put(recommendSuccess());
        yield call(showToastMessage, 'Recommendation sent successfully', 'success');
    } catch (error: any) {
        yield put(recommendFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* saveAdopterWatcher() {
    yield takeLatest(types.SAVE_EMAIL, saveAdopter);
}

function* recommendWatcher() {
    yield takeLatest<any>(types.RECOMMEND, recommend);
}

export default function* adopterSaga() {
    yield all([saveAdopterWatcher(), recommendWatcher()]);
}
